import { render, staticRenderFns } from "./ItemFormLoader.vue?vue&type=template&id=64c0c8ca"
import script from "./ItemFormLoader.vue?vue&type=script&lang=js"
export * from "./ItemFormLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports